<template>
  <nav class="navbar navbar-expand-xl navbar-dark fixed-top MMI-navbar" id="nav" style="padding-top: 5px; padding-bottom: 5px; background: rgb(0, 14, 112) !important;">
    <div class="container-fluid">
      <div id="mainbanner">
        <router-link :to="societyLink" class="navbar-brand">
          <img :src="societyLogo" :alt="societyAlt" id="logo" class="navlogo" style="height: 43px; width: auto;">
        </router-link>
        <router-link :to="homeLink" class="navbar-brand">
          <img :src="homeLogo" :alt="homeAlt" id="logo" class="navlogohome" style="height: 40px; width: auto;">
        </router-link>
      </div>
      <div id="mob">
        <router-link :to="societyLink" class="navbar-brand">
          <img :src="societyLogo" :alt="societyAlt" id="logo" class="navlogo" style="height: 40px; width: auto; margin-top: 2px;">
          <span style="margin-left: 10px;">{{ mobileTitle }}</span>
        </router-link>
        <router-link :to="homeLink" class="navbar-brand">
          <img :src="homeLogo" :alt="homeAlt" id="logo" class="navlogohome" style="height: 40px; width: auto;">
        </router-link>
      </div>
      <button class="navbar-toggler" type="button" 
              aria-controls="navbarsExample06" :aria-expanded="isNavExpanded" aria-label="Toggle navigation" 
              @click="toggleMobileNav">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse" id="navbarsExample06" :class="{ 'show': isNavExpanded }">
        <ul class="navbar-nav ms-auto mb-2 mb-md-0">
          <li class="nav-item" v-for="(item, index) in displayNavItems" :key="index">
            <router-link 
              v-if="item.type === 'router'"
              class="nav-link MMI-navlink btn4" 
              :to="item.to" 
              :id="item.id"
              @click="handleNavItemClick"
            >
              {{ item.text }}
            </router-link>
            <a 
              v-else
              class="nav-link MMI-navlink btn4" 
              :href="item.href" 
              :target="item.target || '_self'"
              :id="item.id"
              @click="handleNavItemClick"
            >
              {{ item.text }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { apiService } from '@/config/api'

export default {
  name: 'CommonNavbar',
  data() {
    return {
      isNavExpanded: false,
      userInfo: null, // 用户信息
      isLoadingUser: false, // 是否正在加载用户信息
      hasToken: false // 是否有token（用于响应式更新）
    }
  },
  props: {
    // 导航栏配置
    societyLink: {
      type: String,
      default: '/official'
    },
    societyLogo: {
      type: String,
      default: require('@/assets/aogs2025/img/isacio.png')
      // default: require('@/assets/society/img/myimages/isacio.png')
    },
    societyAlt: {
      type: String,
      default: 'Society'
    },
    homeLink: {
      type: String,
      default: 'ISACI2025'
    },
    homeLogo: {
      type: String,
      default: require('@/assets/aogs2025/img/HOME.png')
    },
    homeAlt: {
      type: String,
      default: 'Home'
    },
    mobileTitle: {
      type: String,
      default: ''
    },
    // 导航菜单项
    navItems: {
      type: Array,
      default: () => [
      {
          text: 'HOME',
          type: 'router',
          to: '/ISACI2025',
          id: 'navlink3'
        },
        
        {
          text: 'INFORMATION',
          type: 'router',
          to: '/meetings/information',
          id: 'navlink2'
        },

        {
          text: 'LOGIN',
          type: 'router',
          to: '/login',
          target: '_blank',
          id: 'navlink1'
        },
      ]
    }
  },
  computed: {
    // 动态生成导航菜单项
    displayNavItems() {
      const items = [...this.navItems]
      
      // 查找 LOGIN 项并替换
      const loginIndex = items.findIndex(item => item.id === 'navlink1')
      if (loginIndex !== -1) {
        if (this.isLoggedIn && this.userInfo) {
          // 已登录：显示尊称+用户名
          const displayName = this.getUserDisplayName()
          items[loginIndex] = {
            text: displayName,
            type: 'router',
            to: '/announcements', // 可以改为用户中心页面
            id: 'navlink1'
          }
        } else {
          // 未登录：显示 LOGIN
          items[loginIndex] = {
            text: 'LOGIN',
            type: 'router',
            to: '/login',
            target: '_blank',
            id: 'navlink1'
          }
        }
      }
      
      return items
    },
    // 检查是否已登录
    isLoggedIn() {
      return this.hasToken && this.userInfo !== null
    }
  },
  created() {
    // 检查登录状态并获取用户信息
    this.checkLoginAndGetUserInfo()
  },
  mounted() {
    // 监听点击事件，点击导航项时关闭导航栏
    document.addEventListener('click', this.handleOutsideClick)
    
    // 初始化滚动效果
    this.initScrollEffect()
    
    // 监听路由变化，更新用户信息（用于登录后跳转的情况）
    // 只在 token 状态可能变化时更新（避免频繁调用 API）
    this.$watch('$route', () => {
      const currentToken = !!localStorage.getItem('authToken')
      if (currentToken !== this.hasToken) {
        this.checkLoginAndGetUserInfo()
      }
    })
  },
  beforeDestroy() {
    // 清理事件监听器
    document.removeEventListener('click', this.handleOutsideClick)
    
    // 清理滚动监听器
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler)
    }
  },
  methods: {
    // 检查登录状态并获取用户信息
    async checkLoginAndGetUserInfo() {
      const token = localStorage.getItem('authToken')
      this.hasToken = !!token
      
      if (token) {
        this.isLoadingUser = true
        try {
          const response = await apiService.auth.getProfile()
          if (response.data && response.data.data) {
            this.userInfo = response.data.data
          }
        } catch (error) {
          console.error('获取用户信息失败:', error)
          // 如果获取失败（如token过期），清除token
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('authToken')
            this.hasToken = false
            this.userInfo = null
          }
        } finally {
          this.isLoadingUser = false
        }
      } else {
        this.userInfo = null
      }
    },
    // 获取用户显示名称（尊称+用户名）
    getUserDisplayName() {
      if (!this.userInfo) return 'LOGIN'
      
      const title = this.userInfo.title || ''
      const firstName = this.userInfo.first_name || ''
      const lastName = this.userInfo.last_name || ''
      
      // 组合尊称和姓名，去除多余空格
      const displayName = [title, firstName, lastName]
        .filter(part => part.trim())
        .join(' ')
        .trim()
      
      return displayName || 'User'
    },
    toggleMobileNav() {
      // 切换导航栏展开状态
      this.isNavExpanded = !this.isNavExpanded
      // 触发移动端导航切换事件
      this.$emit('mobile-nav-toggle', this.isNavExpanded)
    },
    handleOutsideClick(event) {
      // 如果导航栏是展开的，且点击的不是导航栏内部元素，则关闭导航栏
      if (this.isNavExpanded) {
        const navbar = this.$el
        const isClickInside = navbar.contains(event.target)
        
        if (!isClickInside) {
          this.isNavExpanded = false
        }
      }
    },
    handleNavItemClick() {
      // 点击导航项时关闭导航栏
      this.isNavExpanded = false
    },
    changeNavBg(color) {
      const nav = document.getElementById("nav");
      const navlink1 = document.getElementById("navlink1");
      const navlink2 = document.getElementById("navlink2");
      const navlink3 = document.getElementById("navlink3");
      const navlink4 = document.getElementById("navlink4");
      
      if (nav) {
        nav.style.background = "#000E70";
        nav.style.boxShadow = "none";
      }
      
      [navlink1, navlink2, navlink3, navlink4].forEach(link => {
        if (link) link.style.color = "white";
      });
    },
    initScrollEffect() {
      const nav = document.getElementById('nav');
      const navlink1 = document.getElementById("navlink1");
      const navlink2 = document.getElementById("navlink2");
      const navlink3 = document.getElementById("navlink3");
      const navlink4 = document.getElementById("navlink4");
      
      if (nav) {
        // 创建滚动处理函数
        this.scrollHandler = () => {
          if (window.pageYOffset > 50) {
            nav.style.background = "#000E70";
            nav.style.boxShadow = "none";
            [navlink1, navlink2, navlink3, navlink4].forEach(link => {
              if (link) link.style.color = "white";
            });
          } else {
            nav.style.background = "transparent";
            nav.style.boxShadow = "none";
            [navlink1, navlink2, navlink3, navlink4].forEach(link => {
              if (link) link.style.color = "white";
            });
          }
        };
        
        // 添加滚动监听器
        window.addEventListener('scroll', this.scrollHandler);
        
        // 初始化状态
        this.scrollHandler();
      }
    }
  }
}
</script>

<style scoped>
/* 导航栏基础样式 - 与AOGS2025保持一致 */
.MMI-navbar {
  background: transparent;
  transition: background-color 0.3s ease;
  padding: 0;
}

/* 确保 container-fluid 使用 flex 布局 */
.MMI-navbar .container-fluid {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: 1300px; margin: auto;
}

/* 导航链接样式 - 与AOGS2025保持一致 */
.MMI-navlink {
  color: white !important;
  font-size: 13px;
  font-weight: 600;
  margin-right: 3px;
  margin-left: 3px;
  position: relative;
  transition: 0.7s;
  text-decoration: none;
}

.MMI-navlink:hover,
.MMI-navlink:focus,
.MMI-navlink:active,
.MMI-navlink.active,
.open > .dropdown-toggle.MMI-navlink {
  color: white !important;
  text-decoration: none;
  transition: 0.7s;
}

/* 下划线动画效果 - 与AOGS2025保持一致 */
.btn4::before {
  content: '';
  position: absolute;
  bottom: 0%;
  left: 0px;
  width: 100%;
  height: 3px;
  background: #FFB702;
  display: block;
  -webkit-transform-origin: right top;
  -ms-transform-origin: right top;
  transform-origin: right top;
  -webkit-transform: scale(0, 1);
  -ms-transform: scale(0, 1);
  transform: scale(0, 1);
  -webkit-transition: transform 0.4s cubic-bezier(1, 0, 0, 1);
  transition: transform 0.4s cubic-bezier(1, 0, 0, 1)
}

.btn4:hover::before {
  -webkit-transform-origin: left top;
  -ms-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: scale(1, 1);
  -ms-transform: scale(1, 1);
  transform: scale(1, 1);
  text-shadow: 1px 1px 5px #000E70, 0 0 12px rgba(0,0,0,.5), 0 0 10px rgba(0,0,0,.5);
}

/* Logo样式 - 与AOGS2025保持一致 */
.navbar-brand {
  height: 55px;
  display: flex;
  align-items: center;
}

.navlogo {
  height: 43px;
  margin-top: -1px;
  transition: all 0.3s ease;
}

.navlogohome {
  height: 40px;
  margin-top: -1px;
  transition: all 0.3s ease;
}

/* 左侧品牌区域横向排列 */
#mainbanner {
  display: flex;
  align-items: center;
}

#mainbanner .navbar-brand {
  margin-right: 10px;
}

#mob {
  display: none;
}

/* 移动端样式 */
@media (max-width: 1199.98px) {
  #mainbanner {
    display: none;
  }
  
  #mob {
    display: flex;
    align-items: center;
  }
  
  #mob .navbar-brand {
    margin-right: 10px;
  }
  
  /* 移动端导航栏控制 */
  .navbar-collapse {
    display: none;
  }
  
  .navbar-collapse.show {
    display: block !important;
  }
}

@media (min-width: 1200px) {
  #mob {
    display: none;
  }
  
  #mainbanner {
    display: flex;
    align-items: center;
  }
}

/* 确保导航项靠右对齐 */
.navbar-nav.ms-auto {
  margin-left: auto !important;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .navbar-nav {
    text-align: center;
  }
  
  .MMI-navlink {
    margin: 4px 0;
  }
}
</style>

